(function () {
  'use strict';

  var INIT_ATTRIBUTE = 'data-cbh-brand-master-ready';

  function normalise(value) {
    return (value || '').toString().trim().toLocaleLowerCase('en-GB');
  }

  function initBrandDirectory(section) {
    if (!section || section.hasAttribute(INIT_ATTRIBUTE)) return;

    var search = section.querySelector('[data-brand-search]');
    var clear = section.querySelector('[data-brand-clear]');
    var reset = section.querySelector('[data-brand-reset]');
    var nav = section.querySelector('[data-brand-az]');
    var status = section.querySelector('[data-brand-status]');
    var empty = section.querySelector('[data-brand-empty]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-brand-card]'));
    var buttons = nav ? Array.prototype.slice.call(nav.querySelectorAll('[data-letter]')) : [];

    if (!search || !cards.length || !buttons.length) return;
    section.setAttribute(INIT_ATTRIBUTE, 'true');

    var activeLetter = 'ALL';
    var letterCounts = {};
    var debounceTimer;

    cards.forEach(function (card) {
      card._brandTitle = normalise(card.getAttribute('data-brand-title'));
      card._brandLetter = (card.getAttribute('data-brand-letter') || '').toUpperCase();
      if (card._brandLetter) {
        letterCounts[card._brandLetter] = (letterCounts[card._brandLetter] || 0) + 1;
      }
    });

    buttons.forEach(function (button) {
      var letter = (button.getAttribute('data-letter') || '').toUpperCase();
      if (letter !== 'ALL' && !letterCounts[letter]) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
    });

    function getEnabledButtons() {
      return buttons.filter(function (button) { return !button.disabled; });
    }

    function updatePressedState() {
      var enabledButtons = getEnabledButtons();
      var activeButton = enabledButtons.find(function (button) {
        return (button.getAttribute('data-letter') || '').toUpperCase() === activeLetter;
      }) || enabledButtons[0];

      buttons.forEach(function (button) {
        var isActive = (button.getAttribute('data-letter') || '').toUpperCase() === activeLetter;
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.tabIndex = button === activeButton ? 0 : -1;
      });
    }

    function updateResults() {
      var query = normalise(search.value);
      var visible = 0;

      cards.forEach(function (card) {
        var matchesSearch = !query || card._brandTitle.indexOf(query) !== -1;
        var matchesLetter = activeLetter === 'ALL' || card._brandLetter === activeLetter;
        var shouldShow = matchesSearch && matchesLetter;
        card.hidden = !shouldShow;
        if (shouldShow) visible += 1;
      });

      if (clear) clear.hidden = !query;
      if (empty) empty.hidden = visible !== 0;

      if (status) {
        var noun = visible === 1 ? 'brand' : 'brands';
        if (query) {
          status.textContent = 'Showing ' + visible + ' ' + noun + ' matching “' + search.value.trim() + '”';
        } else if (activeLetter !== 'ALL') {
          status.textContent = 'Showing ' + visible + ' ' + noun + ' beginning with ' + activeLetter;
        } else {
          status.textContent = 'Showing ' + visible + ' ' + noun;
        }
      }
    }

    function showAll(options) {
      activeLetter = 'ALL';
      search.value = '';
      updatePressedState();
      updateResults();
      if (options && options.focusSearch) search.focus();
    }

    search.addEventListener('input', function () {
      window.clearTimeout(debounceTimer);
      activeLetter = 'ALL';
      updatePressedState();
      debounceTimer = window.setTimeout(updateResults, 80);
    });

    search.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && search.value) {
        showAll({ focusSearch: true });
      }
    });

    if (clear) {
      clear.addEventListener('click', function () {
        showAll({ focusSearch: true });
      });
    }

    if (reset) {
      reset.addEventListener('click', function () {
        showAll({ focusSearch: true });
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        activeLetter = (button.getAttribute('data-letter') || 'ALL').toUpperCase();
        search.value = '';
        updatePressedState();
        updateResults();
      });
    });

    if (nav) {
      nav.addEventListener('keydown', function (event) {
        var current = event.target.closest && event.target.closest('[data-letter]');
        if (!current || current.disabled) return;

        var enabledButtons = getEnabledButtons();
        var currentIndex = enabledButtons.indexOf(current);
        if (currentIndex === -1) return;

        var nextIndex = currentIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % enabledButtons.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + enabledButtons.length) % enabledButtons.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = enabledButtons.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        enabledButtons[nextIndex].focus();
      });
    }

    updatePressedState();
    updateResults();
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    scope.querySelectorAll('[data-cbh-brand-master]').forEach(initBrandDirectory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches && event.target.matches('[data-cbh-brand-master]')) {
      initBrandDirectory(event.target);
    } else {
      initAll(event.target);
    }
  });
})();
